export const urls = {
  paymentMethods: () => "/api/client/v1/payments/payment-methods/",
  paymentMethod: (id: number) => `/api/client/v1/payments/payment-methods/${id}/`,
  setupIntents: () => "/api/client/v1/payments/setup-intents/",
  stripeCardDeclineCodes: () => "/api/client/v1/payments/stripe-card-decline-codes/",
};

export const keys = {
  all: () => ["payments"],
  // payments
  stripeCardDeclineCodes: () => [...keys.all(), "stripe-card-decline-codes"],
};
